import React from 'react';
import OtpInput from 'react-otp-input';
import { FormItem } from '../styles';
import styled from 'styled-components';

const OtpInputWrapper = styled.div<{ margin?: string }>`
  display: flex;
  justify-content: center;
  margin: 24px 0;
  padding: 0 8px;

  .otp-container {
    display: flex !important;
    gap: 20px !important;
    justify-content: center !important;
    align-items: center !important;

    @media (max-width: 768px) {
      gap: 18px !important;
    }

    @media (max-width: 480px) {
      gap: 16px !important;
    }

    @media (max-width: 360px) {
      gap: 14px !important;
    }
  }

  input {
    width: 56px !important;
    height: 56px !important;
    border-radius: 12px !important;
    border: 2px solid #e0e0e0 !important;
    background-color: #ffffff !important;
    font-size: 20px !important;
    font-weight: 700 !important;
    text-align: center !important;
    color: #1a202c !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04) !important;
    margin: ${({ margin }) => margin || '0 10px !important'};

    &::placeholder {
      color: #cbd5e0 !important;
    }

    &:hover:not(:disabled) {
      border-color: #2D6CCA !important;
      box-shadow: 0 4px 8px rgba(45, 108, 202, 0.12) !important;
    }

    &:focus {
      border-color: #2D6CCA !important;
      outline: none !important;
      box-shadow: 0 0 0 4px rgba(45, 108, 202, 0.15), 0 4px 12px rgba(45, 108, 202, 0.2) !important;
    }

    &:disabled {
      background-color: #f7fafc !important;
      cursor: not-allowed !important;
      opacity: 0.6 !important;
    }

    @media (max-width: 768px) {
      width: 50px !important;
      height: 50px !important;
      font-size: 18px !important;
      border-radius: 10px !important;
      margin-right: 18px !important;
      margin-left: 0 !important;

      &:last-child {
        margin-right: 0 !important;
      }
    }

    @media (max-width: 480px) {
      width: 46px !important;
      height: 46px !important;
      font-size: 17px !important;
      border-radius: 10px !important;
      margin-right: 16px !important;
      margin-left: 0 !important;

      &:last-child {
        margin-right: 0 !important;
      }
    }

    @media (max-width: 360px) {
      width: 42px !important;
      height: 42px !important;
      font-size: 16px !important;
      border-radius: 8px !important;
      margin-right: 14px !important;
      margin-left: 0 !important;

      &:last-child {
        margin-right: 0 !important;
      }
    }
  }
`;

interface CodeInputProps {
  code: string;
  onCodeChange: (code: string) => void;
  onKeyDown: (index: number, e: React.KeyboardEvent<HTMLInputElement>) => void;
  margin?: string;
}

const CodeInput: React.FC<CodeInputProps> = ({ code, onCodeChange, onKeyDown, margin }) => {
  const handleChange = (otp: string): void => {
    onCodeChange(otp);
  };

  return (
    <FormItem>
      <OtpInputWrapper margin={margin}>
        <OtpInput
          value={code}
          onChange={handleChange}
          numInputs={6}
          renderInput={(inputProps, index) => (
            <input
              {...inputProps}
              data-index={index}
              onKeyDown={(e) => onKeyDown(index, e)}
            />
          )}
          inputType="number"
          shouldAutoFocus
        />
      </OtpInputWrapper>
    </FormItem>
  );
};

export default CodeInput;
